import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

// Checkbox z niebieskim wypełnieniem po zaznaczeniu (appearance-none + własna fajka) —
// spójny wygląd niezależnie od przeglądarki (accent-color bywa różnie renderowany).
const CheckBox = ({ checked, onChange, label, className = '' }) => (
  <label className={`flex items-center gap-2 cursor-pointer ${className}`}>
    <span className="relative inline-flex h-[18px] w-[18px] items-center justify-center shrink-0">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="peer appearance-none h-[18px] w-[18px] rounded border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 hover:border-blue-400 transition-colors cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1"
      />
      <FontAwesomeIcon icon={faCheck} className="pointer-events-none absolute text-white text-[10px] opacity-0 peer-checked:opacity-100" />
    </span>
    {label != null && <span className="text-sm text-gray-700 select-none">{label}</span>}
  </label>
);

export default CheckBox;
